export default __webpack_public_path__ + "static/media/time.43db4322.svg";